const APP_VERSION = import.meta.env.VITE_APP_VERSION ?? "dev";
const BUILD_SHA = import.meta.env.VITE_BUILD_SHA ?? "local";
const APP_ENV = import.meta.env.VITE_APP_ENV ?? "local";
const BUILD_TIME = import.meta.env.VITE_BUILD_TIME ?? "";

// Formata no fuso local do usuário (browser TZ). Tooltip no <span> tem o
// ISO original em UTC pra quem precisar confirmar.
const formatBuildTime = (iso: string): string => {
  if (!iso) return "now";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
    d.getDate()
  )} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const Footer = () => {
  const buildTimeLabel = formatBuildTime(BUILD_TIME);
  return (
    <footer className="border-t border-zinc-200 dark:border-zinc-800 bg-white/50 dark:bg-zinc-900/50">
      <div className="max-w-5xl mx-auto px-6 py-3 text-xs text-zinc-500 dark:text-zinc-500 flex items-center justify-end gap-2 flex-wrap">
        <span>v{APP_VERSION}</span>
        <span aria-hidden>·</span>
        <span className="font-mono">{BUILD_SHA}</span>
        <span aria-hidden>·</span>
        <span title={BUILD_TIME || undefined}>{buildTimeLabel}</span>
        <span aria-hidden>·</span>
        <span>{APP_ENV}</span>
      </div>
    </footer>
  );
};
